/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Operationhours1Inputs */



/**
* | output |
* | --- |
* | "Operation hours" |
*
* @param {Br_History_Key_Operationhours1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_operationhours1 = /** @type {((inputs?: Br_History_Key_Operationhours1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Operationhours1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Operation hours")
	return /** @type {LocalizedString} */ ("Heures de fonctionnement")
});
export { br_history_key_operationhours1 as "br_history_key_operationHours" }